import PropTypes from 'prop-types';

import { Button, Modal, Text } from '@mantine/core';

export default function PublishAllAlert({ opened, close, handleOnConfirm }) {
  return (
    <Modal opened={opened} onClose={close} title="Publish All Menus">
      <Text mb="24">
        Are you sure? This will publish all menus for all integrations for this merchant.
      </Text>
      <Button fullWidth onClick={handleOnConfirm}>
        Resume
      </Button>
      <Button mt="16" fullWidth variant="outline" onClick={close}>
        Cancel
      </Button>
    </Modal>
  );
}

PublishAllAlert.propTypes = {
  close: PropTypes.func,
  handleOnConfirm: PropTypes.func,
  opened: PropTypes.bool,
};
